import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Unit} from '../DTO/unit';
import {UnitProperties} from '../DTO/unitProperties';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UnitModel} from '../models/unit.model';
import {UnitPropertiesModel} from '../models/unit-properties.model';
import {UnitConverter} from '../converters/unit.converter';
import {UnitPropertiesConverter} from '../converters/unit-properties.converter';
import {TreeUnitResearchModel} from '../models/tree-unit-research.model';
import {TreeUnitResearchConverter} from '../converters/tree-unit-research.converter';
import {Observable} from 'rxjs';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { ClientAccountService } from './client-account.service';

@Injectable({
  providedIn: 'root'
})
export class UnitService {

  constructor(
    private httpClient: HttpClient,
    private unitConverter: UnitConverter,
    private unitPropertiesConverter: UnitPropertiesConverter,
    private treeUnitResearchConverter: TreeUnitResearchConverter,
    private configurationService: ConfigurationService,
    private clientAccountService: ClientAccountService
    ) {
  }

  private getBaseResourceEndpoint(): string {
    return (
      this.configurationService.configuration.api.unit
    );
  }

  getUnitTree(treeUnitResearchModel: TreeUnitResearchModel): Observable<UnitModel> {
    let params = this.treeUnitResearchConverter.convertToDto(treeUnitResearchModel);
    return this.httpClient.post(`${this.getBaseResourceEndpoint()}/tree`, params)
      .pipe(
        map((res: Unit) => this.unitConverter.convertToModel(res))
      );
  }

  getUnitProperties(): Observable<UnitPropertiesModel> {
    return this.httpClient.get(`${this.getBaseResourceEndpoint()}/unitProperties`)
      .pipe(
        map((res: UnitProperties) => this.unitPropertiesConverter.convertToModel(res))
      );
  }
}
